import React, { useEffect, useMemo } from 'react'
import { Form, InputGroup } from "react-bootstrap"
import { FaEnvelope, FaPhone } from 'react-icons/fa'
import utils from '../../modules/utils'
import { useSelector } from 'react-redux'
import { Formatter } from 'gf-ui'

const TelefonoEmail = ({telefono, onChangeTelefono, email, onChangeEmail, privacy, onChangePrivacy}) => {

  const user = useSelector( state => state.user )
  const pageData = useSelector( state => state.page.data )      
  const TELEFONO = useMemo(()=> telefono || (pageData && pageData.DETTAGLIO_UTENTE && pageData.DETTAGLIO_UTENTE.TELEFONO), [pageData, telefono]) 
  const EMAIL = useMemo(()=> pageData.LAYOUT_CLIENTE === 'RM1' ? "" : (email || (pageData && pageData.DETTAGLIO_UTENTE && pageData.DETTAGLIO_UTENTE.EMAIL) || (user && user.email)), [email, pageData, user]) 

  useEffect(()=>{
    onChangeTelefono(TELEFONO)
    onChangeEmail(EMAIL)
  }, [TELEFONO, EMAIL, onChangeTelefono, onChangeEmail])

  return (
    <div className="my-4">      
      { pageData.LAYOUT_CLIENTE === 'RM1' ? (
        <label style={{fontSize: 24}}>Conferma e/o modifica il recapito per essere ricontatto</label>                                        
      )
      :
      (
        <label style={{fontSize: 24}}>Inserisci il tuo numero di telefono per eventuali comunicazioni</label>                                        
      )}
      <InputGroup className="mb-3">
        <InputGroup.Text id="basic-addon1"><FaPhone /> </InputGroup.Text>
        <Form.Control aria-label={"Telefono"} 
                      style={{fontSize: '1.5em'}} 
                      onChange={(e) => isNaN(e.target.value) ? null : onChangeTelefono(e.target.value)} 
                      value={TELEFONO} 
                      required={Formatter.isStringaVuota(EMAIL)} 
                      className={(telefono.length >= 9) ? "is-valid" : (telefono.length > 0 && telefono.length < 9) ? "is-invalid" : ""} 
                      placeholder="Telefono"
                      />                                
      </InputGroup>

      { pageData.LAYOUT_CLIENTE !== 'RM1' && (
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1"><FaEnvelope /> </InputGroup.Text>
          <Form.Control type="email"
                        aria-label={"Email"} 
                        style={{fontSize: '1.5em'}} 
                        onChange={(e) => onChangeEmail(e.target.value)} 
                        value={EMAIL} 
                        required={Formatter.isStringaVuota(TELEFONO)} 
                        className={(email && email.length > 0 && utils.validateEmail(email)) ? "is-valid" : (email && email.length > 0 && !utils.validateEmail(email)) ? "is-invalid" : "" } 
                        placeholder="Email"
                        />                                
        </InputGroup>
      )}

      <Form.Check
        disabled={false}
        type={'checkbox'}
        label={<span className='ms-2'>Ho letto e compreso l'informativa sulla privacy</span>}
        id={`privacy-check`}
        className="text-dark"
        checked={privacy}                                
        onChange={(e)=>onChangePrivacy(e.target.checked)}
        required
      />
      <a href={`/portaleMedici/${pageData.NOME_FILE_PRIVACY_POLICY}`} target="_blank" rel="noreferrer" className="ms-2">Informativa privacy</a>
    </div>
  )
}

export default TelefonoEmail;